import { render, staticRenderFns } from "./patientsPortalClaims.vue?vue&type=template&id=6f762f9e&"
import script from "./patientsPortalClaims.vue?vue&type=script&lang=js&"
export * from "./patientsPortalClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports